// mui
import { makeStyles } from '@material-ui/core/styles'

// custom components
import FormTextField from '../../../2compounds/FormTextField'
import ShowHideButton from '../../../1elements/Buttons/IconButtons/ShowHideButton'
import DragIconButton from '../../../1elements/Buttons/IconButtons/DragIconButton'
import { Text } from '../../../1elements'

// third party libraries
import { Reorder, useDragControls } from 'framer-motion'
import DataTypeDropDown from '../../../2compounds/Select/DataTypeDropDown'

const DataAdmin = ({ data = {}, index = 0, fieldIndex = 0, updateFieldLabel, toggleIsHidden, updateDataType }) => {
  const controls = useDragControls()
  const { isMandatory = true, label = '', type = 'Text', isHidden = true, fieldId = '' } = (data || {})
  const classes = useStyles({ isHidden })

  return (
    <Reorder.Item key={fieldId} value={data} drag dragListener={false} dragControls={controls} className={classes.root}>
      <DragIconButton controls={controls} />
      {!isMandatory && (
        <ShowHideButton show={!isHidden} toggleIsHidden={() => toggleIsHidden(index, fieldIndex)} className={classes.showHideButton} />
      )}

      {isMandatory
        ? (<Text>{label} : {type}</Text>)
        : (<>
          <FormTextField value={label} className={classes.textField} onChange={(newValue) => updateFieldLabel(index, fieldIndex, newValue)} />&nbsp;:
          <DataTypeDropDown disabled={isMandatory} value={type} onChange={(newValue) => updateDataType(index, fieldIndex, newValue)} className={classes.typeDropDown} />
        </>
          )}
    </Reorder.Item>
  )
}

export default DataAdmin

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    listStyle: 'none',
    opacity: props => props.isHidden ? 0.6 : 1
  },
  deleteButton: {
    margin: '0px 10px 0px 5px !important',
    width: 14,
    height: 14,
    background: `${theme.palette.quaternary.accent} !important`,
    borderRadius: '5px !important',
    border: `1px solid ${theme.palette.quaternary.accent} !important`,
    '&:hover': {
      border: `1px solid ${theme.palette.primary.main} !important`
    }
  },
  crossIcon: {
    fontSize: 16
  },
  textField: {
    flexGrow: 1,
    '& .MuiFormControl-root': {
      width: '100%'
    },
    '& .MuiInputBase-input': {
      padding: '1px 3px'
    }
  },
  typeDropDown: {
    height: 23,
    minWidth: 110,
    '& .MuiSelect-select': {
      height: 22
    }
  }
}))
